import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronDown, Waves } from 'lucide-react';
import { motion } from 'framer-motion';

const HeroDemo = () => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: "easeOut" }
  };

  const staggerContainer = {
    animate: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/images/hero3.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-white/30"></div>
      <div 
        className="absolute inset-0"
        style={{
          background: `linear-gradient(135deg, rgba(25, 25, 112, 0.2) 0%, rgba(0, 123, 191, 0.3) 50%, rgba(64, 224, 208, 0.2) 100%)`
        }}
      />
      
      {/* Simplified Background Animation */}
      <motion.div 
        className="absolute top-1/3 right-1/4 w-32 h-32 bg-jade-400/20 rounded-full blur-2xl"
        animate={{ 
          scale: [1, 1.3, 1], 
          opacity: [0.3, 0.7, 0.3] 
        }}
        transition={{ 
          duration: 6, 
          repeat: Infinity, 
          ease: "easeInOut" 
        }}
      />

      <motion.div 
        className="absolute bottom-1/3 left-1/6 w-24 h-24 bg-ocean-400/20 rounded-full blur-xl"
        animate={{ 
          scale: [1.2, 1, 1.2], 
          opacity: [0.4, 0.8, 0.4] 
        }}
        transition={{ 
          duration: 5, 
          repeat: Infinity, 
          ease: "easeInOut",
          delay: 1 
        }}
      />
      
      {/* Content */}
      <motion.div
        className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto"
        variants={staggerContainer}
        initial="initial"
        animate="animate"
      >
        <motion.div 
          className="flex items-center justify-center mb-6"
          variants={fadeInUp}
        >
          <Waves className="text-ocean-500 w-8 h-8 mr-3" />
          <span className="text-deep-600 font-medium tracking-wide text-lg">
            Mar de Jade
          </span>
        </motion.div>

        <motion.h1
          className="font-crimson text-4xl sm:text-5xl lg:text-6xl font-bold text-deep-700 mb-6 antialiased"
          variants={fadeInUp}
          style={{ fontKerning: 'normal', fontFeatureSettings: '"liga" 1, "calt" 1' }}
        >
          Mariscos Premium
          <br />
          <span className="text-ocean-600">Directo del Mar</span>
        </motion.h1>

        <motion.p
          className="text-lg sm:text-xl text-deep-600 mb-8 max-w-2xl mx-auto leading-relaxed font-dmsans antialiased"
          variants={fadeInUp}
          style={{ fontKerning: 'normal' }}
        >
          Ostras, almejas y mariscos frescos de la más alta calidad. 
          Experiencia gourmet para tu hogar.
        </motion.p>

        <motion.div
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
          variants={fadeInUp}
        >
          <Button
            className="bg-ocean-500 hover:bg-ocean-600 text-white px-8 py-3 rounded-full text-lg font-medium transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            onClick={() => {
              const element = document.getElementById('productos');
              element?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Ver Productos
          </Button>
          
          <Button
            variant="outline"
            className="border-2 border-jade-500 text-jade-600 hover:bg-jade-50 px-8 py-3 rounded-full text-lg font-medium transition-all duration-300 hover:shadow-lg"
            onClick={() => {
              const element = document.getElementById('contacto');
              element?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Contactar
          </Button>
        </motion.div>
      </motion.div>

      {/* Scroll Indicator */}
      <motion.div
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
      >
        <ChevronDown className="text-deep-600 w-8 h-8" />
      </motion.div>
    </section>
  );
};

export default HeroDemo;
